import { defineStore } from 'pinia';
import { axiosInstance as axios } from '../plugins/axios';
import { useOrderStore } from './orderStore';
import { useDestinationStore } from './destinationStore';
import { usePeriodStore } from './periodStore';
import { useShipmentStore } from './shipmentStore';
import { usePlanStore } from './planStore';

export const useDeviceStore = defineStore('deviceStore', {
    state: () => {
        return {
            devices: [],
            selectedDevice: null,
            device_quantity: 1,
        }
    },
    persist: {
        pick: ['selectedDevice', 'device_quantity']
    },
    getters: {
        canShowDevicesType: (state) => {
            if (!state.devices.length || !state.selectedDevice) return false;

            const destinationStore = useDestinationStore();
            const shipmentStore = useShipmentStore();
            const planStore = usePlanStore();

            const availableCountryIds = [198];
            const availablePickupLocationIds = [354];
            const destinations = destinationStore.selectedDestinations;
            const pickupLocationApiId = shipmentStore.selectedPickupLocation?.api_pickup_location_id;
            const inPickupLocation = availablePickupLocationIds.includes(pickupLocationApiId);
            const isPlanTypeMonth = planStore.plan_type === 'month';
            const isDelivery = shipmentStore.shipment_type === 'delivery';

            let value = false;

            for (let i = 0; i < destinations.length; i++) {
                if ((isPlanTypeMonth || inPickupLocation) 
                    && availableCountryIds.includes(destinations[i].api_country_id)
                ) {
                    value = true;
                    break;
                }

                if (isDelivery && availableCountryIds.includes(destinations[i].api_country_id)) {
                    value = true;
                    break;
                }
            }

            return value;
        },
        totalExtraCharge(state) {
            const periodStore = usePeriodStore();
            const planStore = usePlanStore();

            const days = periodStore.getMinMaxPeriodDays();
            const deviceQuantity = state.device_quantity;
            const deviceExtraCharge = state.selectedDevice ? state.selectedDevice.extra_charge : 0;

            let totalAmount = 0;
            if (state.selectedDevice && state.selectedDevice.type === "2" /* 5G */ && planStore.plan_type === 'day') {
                for (let i = 1; i <= days; i++) {
                    if (i <= 15) {
                        totalAmount += 3;
                    } else {
                        totalAmount += 2;
                    }
                }
                totalAmount = totalAmount * deviceQuantity;
            } else {
                totalAmount = deviceExtraCharge * deviceQuantity;
            }

            return totalAmount;
        }
    },
    actions: {
        async fetchDevices() {
            const planStore = usePlanStore();

            try {
                const res = await axios.get(`/devices/get-devices`);
                this.devices = res.data;

                if (!this.selectedDevice || !this.selectedDevice?.id) {
                    this.selectedDevice = this.devices.find(device => {
                        return device.type === '1';
                    })
                }

                return res.data;
            } catch (error) {
                console.error("Error fetching devices:", error);
                return error;
            }
        },
        setSelectedDevice(device) {
            this.selectedDevice = device;
        },
    }
});